import type { FC } from "react"

export const SaveOurSoundButton: FC<{ title: string; onClick?: () => void }> = ({
  onClick,
  title,
}) => (
  <button className="flex cursor-pointer w-[236px] relative" onClick={onClick} type="button">
    <div className="absolute text-center w-full flex justify-center items-center uppercase !text-[18px] pt-1 h-[64px] text-[#F4FF00] font-bold">
      {title}
    </div>
    <svg
      fill="none"
      height={64}
      viewBox="0 0 235 64"
      width={235}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 0h171v8H32zm-8 16h8V8h-8V0h-8v8h8zm-8 8v-8h8v8zm0 8v-8H8v-8H0v8h8v8zm8 16h-8V32h8zm8 8v-8h-8v8h-8v8h8v-8zm171 0v8H32v-8zm8-8h-8v8h8v8h8v-8h-8zm8-16v16h-8V32zm0-8v8h8v-8h8v-8h-8v8zm-8-8h8v8h-8zm0-8v8h-8V8zm0 0V0h8v8zM8 40H0v8h8zm219 0h8v8h-8z"
        fill="#000"
      />
      <path d="M32 8h171v8h8v8h8v8h-8v16h-8v8H32v-8h-8V32h-8v-8h8v-8h8z" fill="#000" />
    </svg>
  </button>
)
